import { render, staticRenderFns } from "./widget_preview_item.vue?vue&type=template&id=044c630c&scoped=true"
import script from "./widget_preview_item.vue?vue&type=script&lang=ts"
export * from "./widget_preview_item.vue?vue&type=script&lang=ts"
import style0 from "./widget_preview_item.vue?vue&type=style&index=0&id=044c630c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c630c",
  null
  
)

export default component.exports